import {
  type IIntegrationFormData,
  integrationDataToIntegration,
  integrationToIntegrationData,
} from "src/integrations/forms/IIntegrationFormData";
import type { IntegrationShopify } from "src/integrations/objects/IntegrationShopify";
import type { IntegrationType } from "src/integrations/objects/IntegrationType";

export const INTEGRATION_SHOPIFY_SHOP_DOMAIN = "shopDomain";
export const INTEGRATION_SHOPIFY_API_KEY = "apiKey";
export const INTEGRATION_SHOPIFY_ACCESS_TOKEN = "accessToken";
export const INTEGRATION_SHOPIFY_API_SECRET = "apiSecret";
export const INTEGRATION_SHOPIFY_IS_RESTRICTED = "isRestricted";

// export const INTEGRATION_SHOPIFY_PHONE_LABEL = "phoneLabel";

export interface IIntegrationFormDataShopify extends IIntegrationFormData {
  [INTEGRATION_SHOPIFY_SHOP_DOMAIN]: string;
  [INTEGRATION_SHOPIFY_API_KEY]: string;
  [INTEGRATION_SHOPIFY_ACCESS_TOKEN]?: string;
  [INTEGRATION_SHOPIFY_API_SECRET]: string;
  [INTEGRATION_SHOPIFY_IS_RESTRICTED]: boolean;
  // [INTEGRATION_SHOPIFY_PHONE_LABEL]: string;
}

export function integrationDataToIntegrationShopify(
  integrationType: IntegrationType,
  integrationData: Partial<IIntegrationFormData>,
  integrationUuid?: string,
): Partial<IntegrationShopify> {
  let integration: Partial<IntegrationShopify> = {
    ...integrationDataToIntegration(
      integrationType,
      integrationData,
      integrationUuid,
    ),
    shopDomain: integrationData[INTEGRATION_SHOPIFY_SHOP_DOMAIN],
    isRestricted: false,
    // phoneLabel: integrationData[INTEGRATION_SHOPIFY_PHONE_LABEL],
  };
  if (!integrationUuid) {
    integration = {
      ...integration,
      apiKey: integrationData[INTEGRATION_SHOPIFY_API_KEY],
      ...(integrationData[INTEGRATION_SHOPIFY_ACCESS_TOKEN]
        ? { accessToken: integrationData[INTEGRATION_SHOPIFY_ACCESS_TOKEN] }
        : {}),
      apiSecret: integrationData[INTEGRATION_SHOPIFY_API_SECRET],
    };
  }
  return integration;
}

export function integrationToIntegrationDataShopify(
  integrationType: IntegrationType,
  integration: IntegrationShopify,
): Partial<IIntegrationFormDataShopify> {
  return {
    ...integrationToIntegrationData(integrationType, integration),
    [INTEGRATION_SHOPIFY_SHOP_DOMAIN]: integration.shopDomain,
    [INTEGRATION_SHOPIFY_API_KEY]: integration.apiKey,
    [INTEGRATION_SHOPIFY_ACCESS_TOKEN]: integration.accessToken,
    [INTEGRATION_SHOPIFY_API_SECRET]: integration.apiSecret,
    [INTEGRATION_SHOPIFY_IS_RESTRICTED]: integration.isRestricted,
    // [INTEGRATION_SHOPIFY_PHONE_LABEL]: integration.phoneLabel,
  };
}
